import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Market } from "@/config/markets";

interface MarketState {
  market: Market;
  setMarket: (market: Market) => void;
}

export const useMarketStore = create<MarketState>()(
  persist(
    (set) => ({
      market: "SE",
      setMarket: (market) => set({ market }),
    }),
    { name: "ortvis-market" },
  ),
);
